module.exports = __webpack_public_path__ + "static/media/OTG_ Type_C.dc85be5d.png";